import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/user-auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = auth.getToken();

  if (!token) {
    console.log('No token found');
    return router.parseUrl('/authentication/signin');
  }

  if (auth.isTokenExpired()) {
    auth.logout();
    console.log('Token expired');
    return router.parseUrl('/authentication/signin');
  }

  return true;
};
